<template>
    <div class="main">
        <c-panel>
            <list></list>
        </c-panel>
    </div>
</template>
<script>
import list from "./list"

export default {
    components:{ list }
}
</script>

